import React, { useState } from 'react';
import { Typography, alpha } from '@mui/material';
import { AddContainer, Component4, DropZone, Texts, HeaderPart, FooterPart, SaveButton, CancelButton } from './Style';
import InputSelect from 'src/components/shared/Form/Select';
import theme, { mobileTypography, typography } from 'src/config/theme';
import { ReactComponent as CloseIcon } from '../../../../../../src/assets/images/close-circle.svg';
import { ReactComponent as AddIcon } from '../../../../../../src/assets/images/add-square.svg';
import { palette, shadows } from 'src/config/theme.js';
import ButtonComponent from 'src/components/shared/Button';
import { postUploadRequest } from 'src/modules/app/store/appActions';
import { useSelector, useDispatch } from "react-redux";
import { useParams } from 'react-router-dom';
import { Formik, Form } from "formik";
import * as Yup from "yup";
import useAppointmentDetails from '../../UseAppointmentDetails';
import useResponsive from 'src/components/hooks/useResponsive';
import toast from 'src/utils/toast';

const Report = [
  { label: 'Patient Summary Report', value: 'patient summary report' },
  { label: 'Doctor Consultation Report', value: 'doctor consultation report' },
  { label: 'Health checkup Report', value: 'health checkup report' }
]

function ReportTabForm({ onClose, fetchReports }) {
  const { isMobile, isTablet, isDesktop } = useResponsive();
  const dispatch = useDispatch();
  const { PatientId, user } = useAppointmentDetails();
  console.log("here is my patient id ", PatientId)


  const validationSchema = Yup.object().shape({
    typesOfReports: Yup.string().required('report type must be required'),
    report: Yup.array()
      .min(1, 'At least one file is required')
      .test('fileSize', 'One or more files are too large (max 25MB)', (files) =>
        files.every(file => file.size <= 25 * 1024 * 1024)
      )
      .test('fileFormat', 'One or more files have unsupported format', (files) =>
        files.every(file => ['application/pdf', 'image/png', 'image/jpeg'].includes(file.type))
      )

  })
  const handleSubmit = async (values, { resetForm }) => {
    const formData = new FormData();
    formData.append("user", user);
    formData.append("patient", PatientId);
    formData.append("typesOfReports", values.typesOfReports);

    if (values.report && values.report.length > 0) {
      values.report.forEach(file => {
        formData.append("report", file);
      });
    } else {
      console.log('No file selected');
    }

    for (let pair of formData.entries()) {
      console.log(`${pair[0]}:`, pair[1]);
    }

    try {
      const response = await new Promise((resolve, reject) => {
        dispatch(postUploadRequest(formData, resolve, reject));
      });
      toast.success(response.message || 'Report uploaded successfully');
      console.log('Report upload response:', response);
      if (response?.id && fetchReports) {
        fetchReports();
      }
      onClose();

      resetForm();


    } catch (error) {
      console.error('Failed to upload report:', error);
      toast.error(error?.message || 'Failed to upload report');
      console.log("on Success error", error.message)
    }
  };
  return (
    <>
      <Formik
        enableReinitialize={true}
        initialValues={{
          typesOfReports: '',
          report: []
        }}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ values, errors, touched, handleBlur, handleSubmit, handleChange, setFieldValue }) => (
          <Form>
            <HeaderPart>
              Add Report
              <CloseIcon width={isMobile || isTablet ? 18 : 24}
                height={isMobile || isTablet ? 18 : 24} onClick={onClose} style={{ cursor: 'pointer' }} />
            </HeaderPart>
            <AddContainer>
              <Component4>
                <Texts>Report Type</Texts>
                <InputSelect
                  name="typesOfReports"
                  value={values.typesOfReports}
                  onChange={(val) => setFieldValue('typesOfReports', val)}
                  options={Report}
                  // onChange={handleChange}
                  variant="outlined"
                  placeholder="Choose"
                  onBlur={handleBlur}
                  error={touched.typesOfReports && Boolean(errors.typesOfReports)}
                  helperText={touched.typesOfReports && errors.typesOfReports}
                  sx={{
                    // width: '200px',
                    boxShadow: theme.shadows[1],
                    '& .MuiOutlinedInput-root': {
                      height: '52px',
                      display: 'flex',
                      alignItems: 'center',
                      // border: `1px solid ${alpha(theme.palette.gery.black, 0.14)}`,
                      borderRadius: '12px',
                    },
                  }}
                />

              </Component4>
              <Component4>
                <Texts>Upload Report</Texts>
                <DropZone component="label">

                  <input
                    name="report"
                    type="file"
                    hidden
                    accept=".pdf, .png, .jpg"
                    multiple
                    onChange={(event) => {
                      const files = Array.from(event.currentTarget.files || []);
                      setFieldValue('report', files);
                    }}
                  />


                  {/* {!file ? (
                                        <>
                                            <Typography variant='body1' color={theme.palette.gery.black}>
                                                Drag & Drop File Here or
                                                <span
                                                    style={{
                                                        ...theme.typography.h6,
                                                        color: theme.palette.primary.main,
                                                        cursor: "pointer",
                                                        borderBottom: `1px solid ${theme.palette.primary.main}`,
                                                        marginLeft: 3

                                                    }}
                                                >
                                                    Browse File
                                                </span>
                                            </Typography>
                                            <Typography variant="body1" color={alpha(theme.palette.gery.black, 0.7)}>
                                                (max size: 25MB, type: .pdf, .png, .jpg)
                                            </Typography>
                                        </>
                                    ) : (
                                        <Typography variant="body1" fontWeight="bold" mt={1} color={alpha(theme.palette.gery.black, 0.7)}>
                                            Upload File: <strong style={{ ...theme.typography.h6, color: theme.palette.gery.black }}>{file.name} ({file.size > 1024 * 1024
                                                ? (file.size / (1024 * 1024)).toFixed(2) + " MB"
                                                : (file.size / 1024).toFixed(2) + " KB"})
                                            </strong>
                                        </Typography>
                                    )} */}
                  {!values.report || values.report.length === 0 ? (
                    <>
                      <Typography variant='body1' color={theme.palette.gery.black} sx={{
                        ...((isMobile || isTablet) ? mobileTypography.body1 : typography.body1)
                      }}>
                        Drag & Drop File Here or
                        <span style={{ ...theme.typography.h6, color: theme.palette.primary.main, cursor: "pointer", borderBottom: `1px solid ${theme.palette.primary.main}`, marginLeft: 3 }}>
                          Browse File
                        </span>
                      </Typography>
                      <Typography color={alpha(theme.palette.gery.black, 0.7)} sx={{ ...((isMobile || isTablet) ? mobileTypography.smallRegular : typography.body1) }}>
                        (max size: 25MB, type: .pdf, .png, .jpg)
                      </Typography>
                    </>
                  ) : (
                    values.report.map((file, idx) => (
                      <Typography key={idx} variant="body1" fontWeight="bold" mt={1}>
                        {file.name} ({(file.size / 1024).toFixed(2)} KB)
                      </Typography>
                    ))
                  )}

                </DropZone>

              </Component4>
            </AddContainer>
            <FooterPart >
              <CancelButton
                variant="none"
                startIcon={<CloseIcon width={isMobile || isTablet ? 18 : 24}
                  height={isMobile || isTablet ? 18 : 24} />}
                onClick={onClose}
              >
                Cancel
              </CancelButton>
              <SaveButton
                type="submit"
                variant="outlined"
                startIcon={<AddIcon width={isMobile || isTablet ? 18 : 24}
                  height={isMobile || isTablet ? 18 : 24} sx={{ color: palette.primary.main }} />}

              // onClick={handleSubmit ? () => handleSubmit() : null}
              >
                Save
              </SaveButton>
            </FooterPart>
          </Form>
        )}
      </Formik>
    </>
  )
}

export default ReportTabForm;